import { RefObject } from 'react'

import { HTMLAnchorFragment, IAnnotationEngine } from '@/features/annotation'
import { useAnchorPosition } from '@/features/annotation/hooks'
import { ResponseThread } from '@/schema'

import { CommentAvatar } from './CommentAvatar'

interface CommentAvatarContainerProps {
  comment: ResponseThread
  fragment: HTMLAnchorFragment
  containerRef: RefObject<HTMLElement>
  shadowRootRef: RefObject<ShadowRoot>
  scrollContainerRef?: RefObject<HTMLElement>
  engine: IAnnotationEngine
  isActive: boolean
  onClick: (commentId: string) => void
  offset?: {
    top?: number
    left?: number
  }
}

export const CommentAvatarContainer = ({
  comment,
  fragment,
  containerRef,
  shadowRootRef,
  scrollContainerRef,
  engine,
  isActive,
  onClick,
  offset,
}: CommentAvatarContainerProps) => {
  const { position } = useAnchorPosition({
    fragment,
    containerRef,
    shadowRootRef,
    scrollContainerRef,
    engine,
    enabled: true,
    offset,
  })

  if (!position) {
    return null
  }

  return (
    <div data-comment-avatar>
      <CommentAvatar
        comment={comment}
        position={position}
        isActive={isActive}
        onClick={onClick}
      />
    </div>
  )
}
